export default "__VITE_ASSET__CvJ10Kf9__"